export default __webpack_public_path__ + "static/media/shipping_and_return.1ab46583.pdf";